import { wagmiConfig } from '@/lib/wagmi';
import { Address, formatEther } from 'viem';
import { estimateContractGas, estimateFeesPerGas } from 'viem/actions';

/**
 * Returns the estimated native gas fee for a contract call
 */
export const estimateGas = async (
  userAddress: Address,
  params: Parameters<typeof estimateContractGas>[1],
) => {
  const client = wagmiConfig.getClient();
  const gas = await estimateContractGas(client, {
    ...params,
    account: userAddress,
  });
  const pricePerGas = await estimateFeesPerGas(client);
  const weiGasFee = gas * BigInt(pricePerGas?.maxFeePerGas || 1);
  const nativeGasFee = formatEther(weiGasFee);

  return {
    wei: weiGasFee,
    native: nativeGasFee,
  };
};
